import axiosInstance from './axios.instance';

const notificationService = {
  getMyNotifications: async (page = 1, limit = 20, unreadOnly = false) => {
    const response = await axiosInstance.get('/notifications', {
      params: { page, limit, unreadOnly }
    });
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await axiosInstance.get('/notifications/unread-count');
    return response.data;
  },

  markAsRead: async (notificationId) => {
    const response = await axiosInstance.put(`/notifications/${notificationId}/read`);
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await axiosInstance.put('/notifications/mark-all-read');
    return response.data;
  },

  deleteNotification: async (notificationId) => {
    const response = await axiosInstance.delete(`/notifications/${notificationId}`);
    return response.data;
  },

  notifyCartAddition: async (productData) => {
    const response = await axiosInstance.post('/notifications/cart-addition', {
      productId: productData.id,
      productTitle: productData.title,
      productPrice: productData.price,
      productCategory: productData.category,
      productSubcategory: productData.subcategory
    });
    return response.data;
  }
};

export default notificationService;
